<template>
	<div class="manage">
		<div style="" class="top">
			<el-row>
				<el-col :span="24">
					<div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
						<div style="float: left;">
							
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="table">
					<div ref="height_top">
						<el-table :data="tableData"  row-key="key" :height="tableHeight" ref="singleTable" :header-cell-style="header_table" size="small" style="width: 100%" v-loading="loading">
							<!-- <el-table-column prop="header" label="">
								<template #header>
								
							    </template>
								<el-table-column type="selection" width="55" />
							</el-table-column> -->
							<el-table-column prop="header" label="">
								<template #header>
								
							    </template>
								<el-table-column prop="key" label="行号" width="55" />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								<el-select v-model="form.userinfo" placeholder="选择" style="" clearable>
									<el-option label="本人反馈" value="1" />
									<el-option label="他人反馈" value="2" />
								</el-select>
							    </template>
								<el-table-column prop="type" label="反馈人" width="80" show-overflow-tooltip>
									<template #default="scope">
										<span v-if="scope.row.user_id==user_id">
											本人反馈
										</span>
										<span v-else>
											他人反馈
										</span>
									</template>
								</el-table-column>
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-select v-model="form.type" placeholder="反馈类型"  clearable>
										<el-option label="举报" value="1" />
										<el-option label="索要图片" value="2" />
										<el-option label="核实数量" value="3" />
									</el-select>
							    </template>
								<el-table-column prop="type" label="反馈类型" width="120" show-overflow-tooltip>
									<template #default="scope">
										<span v-if="scope.row.type==1">
											举报
										</span>
										<span v-else-if="scope.row.type==2">
											索要图片
										</span>
										<span v-else-if="scope.row.type==3">
											核实数量
										</span>
									</template>
								</el-table-column>
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.brand_name"  placeholder="品牌">
									</el-input>
							    </template>
								<el-table-column prop="brand_name" label="品牌" width="90" show-overflow-tooltip />
							</el-table-column >
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.name"  placeholder="品名">
									</el-input>
							    </template>
								<el-table-column prop="name" label="品名" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.model"  placeholder="型号">
									</el-input>
							    </template>
								<el-table-column prop="model" label="型号" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.order_no"  placeholder="订货号">
									</el-input>
							    </template>
								<el-table-column prop="order_no" label="订货号" width="150" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								
								<el-table-column prop="num" label="数量" width="60" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
									<el-input v-model="form.remark"  placeholder="留言">
										<template #append>
											<el-button type="primary" class="button" style="width:60px" @click="grabble">
												<el-icon color="#fff" size="12px" class="no-inherit">
													<Search />
												</el-icon>
											</el-button>
										</template>
									</el-input>
							    </template>
								<el-table-column prop="remark" min-width="200" label="留言" width="" show-overflow-tooltip />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								
							    </template>
								<el-table-column prop="create_time" label="反馈时间" width="150" />
							</el-table-column>
							<el-table-column prop="header" label="">
								<template #header>
								
							    </template>
								<el-table-column prop="pro_result" label="处理结果" width="120" />
							</el-table-column>
							<!-- 

							 -->
						</el-table>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background :page-size="parseInt(page_size)" layout="prev, pager, next" @current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import '../../assets/user/index.css' //优化表格样式
export default {
	components: {},
	data() {

		return {
			tableData: [],
			form: {
				name: '',
				userinfo: '',
				type: '',
			},
			loading: false,
			total: 0,
			page: 1,
			tableHeight: 400,
			page_size: 120,
			user_id: '',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.search()
		this.tableHeight_fun()
		this.user_id = localStorage.getItem('user_id');
	},
	watch: {

	},
	methods: {
		header_table(event){
			if (event.column.property=='header') {
				return {'background-color': '#fff'}
			}else{
				return {'background-color': '#e5e5e5'}
			}
			
		},
		grabble() {
			this.page = 1;
			this.search();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
				console.log(this.tableHeight)
			})
		},
		async search() {
			this.loading = true
			var search = this.form;
			search.page = this.page;
			search.ps = this.page_size;
			await this.$axios.post('/api/yunsys.Chat/getreport', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = res.data.total;
					var key = 0;
					res.data.data.forEach(item => {
						key = key + 1
						item.key = (obj.page - 1) * obj.page_size + key

					})
					this.tableData = res.data.data;

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
:deep(.el-table__header .el-table__cell ) {
 // border: none;
}
:deep(.el-table__header .el-table__cell ) {
  //border: none;
}
:deep(thead tr:first-child .cell) {
    padding:0px
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
	.search_remark {
		width: 120px;
	}
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
	.search_remark {
		width: 170px;
	}
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
	.search_remark {
		width: 400px;
		margin-left: 60px
	}
}
</style>